import { type EagerResponse, useApolloRequestWrapper } from '../../../api/useApolloRequestWrapper'
import { useGetRequestContextListQuery, type GetRequestContextListQuery } from '../../../../api'
import { type RequestContext } from '../types'

function mapResponse(data: GetRequestContextListQuery) {
  if (!data.connectPlatformServiceGetRequestContexts?.requestContexts) {
    return []
  }
  return data.connectPlatformServiceGetRequestContexts.requestContexts.map(context => ({
    clientConfigurationId: context.clientConfigurationId!,
    storeConfigurationId: context.storeConfigurationId!,
    countryId: context.countryId!,
  }))
}

export const useGetRequestContextListRequest = (
  retailerId: string,
  partnerId: string
): EagerResponse<RequestContext[]> => {
  const query = useGetRequestContextListQuery({
    variables: {
      retailerId: parseInt(retailerId),
      partnerId: parseInt(partnerId),
    },
    fetchPolicy: 'network-only',
    refetchWritePolicy: 'overwrite',
  })
  return useApolloRequestWrapper({ query, mapResponse })
}
